import { cx } from '@linaria/core';
import { radio, modifiers } from './radio.style.js';
import { jsx } from 'react/jsx-runtime';

function Radio(props) {
  return /*#__PURE__*/jsx("div", {
    className: cx(radio, props.toggled && modifiers.active.className)
  });
}

export { Radio };
//# sourceMappingURL=radio.js.map
